import { useEffect, useState } from 'react';
import ProjectCard from '../components/projects/ProjectCard';
import { getAllProjects } from '../lib/markdown';
import type { Project } from '../types/project';

export default function Projects() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTech, setSelectedTech] = useState<string | null>(null);
  const [allTechs, setAllTechs] = useState<string[]>([]);

  useEffect(() => {
    getAllProjects().then(data => {
      setProjects(data);
      // Extract all unique tech stack items
      const techs = Array.from(new Set(data.flatMap(project => project.techStack)));
      setAllTechs(techs);
      setLoading(false);
    });
  }, []);

  const filteredProjects = selectedTech
    ? projects.filter(project => project.techStack.includes(selectedTech))
    : projects;

  if (loading) {
    return (
      <div className="container-custom py-20">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
          项目展示
        </h1>
        <div className="text-center text-xl">加载中...</div>
      </div>
    );
  }

  return (
    <div className="container-custom py-12">
      <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8 text-center">
        项目展示
      </h1>
      <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto">
        探索我的创意项目和技术实践
      </p>

      {/* Tech filter */}
      {allTechs.length > 0 && (
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          <button
            onClick={() => setSelectedTech(null)}
            className={`px-4 py-2 border-2 border-black rounded-full transition-all ${
              selectedTech === null
                ? 'bg-cta text-white'
                : 'bg-white hover:bg-gray-100'
            }`}
          >
            全部
          </button>
          {allTechs.map((tech) => (
            <button
              key={tech}
              onClick={() => setSelectedTech(tech)}
              className={`px-4 py-2 border-2 border-black rounded-full transition-all ${
                selectedTech === tech
                  ? 'bg-cta text-white'
                  : 'bg-white hover:bg-gray-100'
              }`}
            >
              {tech}
            </button>
          ))}
        </div>
      )}

      {filteredProjects.length === 0 ? (
        <div className="text-center text-xl text-gray-600 py-12">
          {selectedTech ? `没有找到使用 "${selectedTech}" 的项目` : '暂无项目展示'}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <ProjectCard key={project.slug} project={project} />
          ))}
        </div>
      )}
    </div>
  );
}
